module.exports = __webpack_public_path__ + "img/mobileicon.06f18186.svg";